const ConsoleHelper = (data) => {
    if (process.env.REACT_APP_STAGE_NAME === 'Dev' || process.env.REACT_APP_STAGE_NAME === 'Prod') return;
    console.log(data);
  }
  
  export default ConsoleHelper;